<template>
	<v-container fluid class="flex-grow-1">
		<v-form ref="form" :disabled="disableForm">
			<v-row><h2>Account Details:</h2> </v-row>
			<v-row>
				<v-col>
					<v-text-field
						v-model="FirstName"
						label="First Name"
						:rules="[rules.required]"
					/>
				</v-col>
				<v-col>
					<v-text-field
						v-model="LastName"
						label="Last Name"
						:rules="[rules.required]"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col v-if="usernameVisible">
					<v-text-field
						v-model="Username"
						label="Domain \ Username"
						:rules="usernameOrEmailRules"
					/>
				</v-col>
				<v-col>
					<v-text-field
						v-model="Email"
						label="Email"
						:rules="emailRules"
					/>
				</v-col>
			</v-row>
			<v-row v-if="emailAndPassVisible">
				<v-col>
					<v-text-field
						v-model="Password"
						:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
						:type="showPassword ? 'text' : 'password'"
						@click:append="togglePassVisibility"
						label="Password"
						:rules="passRules"
					/>
					<password-meter :password="Password" />
				</v-col>
				<v-col>
					<v-text-field
						v-model="ConfirmPassword"
						:append-icon="
							showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'
						"
						:type="showConfirmPassword ? 'text' : 'password'"
						@click:append="toggleConfirmPassVisibility"
						label="Password confirm"
						:rules="confirmPassRules"
					/>
				</v-col>
			</v-row>
			<v-row>
				<h2>Contact Details:</h2>
			</v-row>
			<v-row>
				<v-col>
					<v-text-field
						v-model="PhoneNumber"
						label="Phone Number"
						:rules="phoneNumberRules"
					/>
				</v-col>

				<v-col>
					<v-text-field v-model="Address" label="Address" />
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-text-field v-model="City" label="City" />
				</v-col>

				<v-col>
					<v-text-field v-model="State" label="State" />
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-text-field v-model="ZipCode" label="ZipCode" />
				</v-col>
				<v-col>
					<v-text-field v-model="Company" label="Company" />
				</v-col>
			</v-row>
		</v-form>
	</v-container>
</template>
<script>
import { Permissions } from '../../../enums/permissionsEnum';
import permissionsMixin from '../../../mixins/permissionsMixin';
import { mapGetters } from 'vuex';
import { AuthGetterTypes, ClientContextGetters } from '../../../store/getters';
import { IrisLoginMethod } from '../../../enums/irisLoginMethod';
import passwordMeter from 'vue-simple-password-meter';
export default {
	name: 'EditUserFields',
	mixins: [permissionsMixin],
	components: { passwordMeter },
	props: {
		selectedUser: Object,
		adminFields: Boolean,
	},
	data() {
		return {
			showPassword: false,
			showConfirmPassword: false,
			showDialog: false,
			showPermissionDialog: false,
			Id: null,
			FirstName: null,
			LastName: null,
			Username: null,
			Email: null,
			Password: null,
			ConfirmPassword: null,
			PhoneNumber: null,
			Address: null,
			City: null,
			State: null,
			ZipCode: null,
			Company: null,

			rules: {
				required: (value) => !!value || 'Field is required',
				email: (value) => {
					const pattern =
						/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					return pattern.test(value) || 'Invalid email format';
				},
				passwordMatch: (v) =>
					v === this.Password || 'Password must match!',
				passwordLength: (v) => {
					if (v)
						return (
							v.length >= 8 ||
							'Password must be at least eight characters long'
						);
					return 'Password must be at least eight characters long';
				},
				passwordContainsNumber: (v) =>
					/\d/.test(v) || 'Password must contain at least one number',
				passwordHasLowerCase: (v) =>
					String(v).toUpperCase() != v ||
					'Password must contain at least one lower-case letter',
				passwordHasUpperCase: (v) =>
					String(v).toLowerCase() != v ||
					'Password must contain at least one upper-case letter',
				passwordContainsSpecialCharacter: (v) => {
					const pattern = /[!@#$%&=]+/;
					return (
						pattern.test(v) ||
						'Password must contain at least one special character (!, @, #, $, %, &, =)'
					);
				},
			},

			phoneNumberRules: [
				(v) =>
					/^[0-9+-\s]*$/.test(v) ||
					v == undefined ||
					'Phone number must contains only numbers',
			],
		};
	},
	computed: {
		usernameVisible() {
			if (this.adminFields) return true;
			if (!this.selectedClient) return false;
			return this.selectedClient.LoginMethod == IrisLoginMethod.Windows;
		},
		emailAndPassVisible() {
			if (this.adminFields) return true;
			if (!this.selectedClient) return false;
			return this.selectedClient.LoginMethod == IrisLoginMethod.Forms;
		},

		usernameOrEmailRules() {
			let rules = [];
			if (!this.Email && !this.Username) rules.push(this.rules.required);
			return rules;
		},
		emailRules() {
			let rules = [];
			rules.push(this.rules.required, this.rules.email);
			return rules;
		},

		passRules() {
			let rules = [];
			if (this.Id && (!this.Password || this.Password == '')) return [];
			if (!this.Username)
				rules.push(
					this.rules.required,
					this.rules.passwordLength,
					this.rules.passwordContainsNumber,
					this.rules.passwordContainsSpecialCharacter,
					this.rules.passwordHasLowerCase,
					this.rules.passwordHasUpperCase
				);
			return rules;
		},
		confirmPassRules() {
			let rules = [];
			if (this.passRules.length > 0)
				rules.push(this.rules.required, this.rules.passwordMatch);
			return rules;
		},

		...mapGetters({
			isAdmin: [AuthGetterTypes.IS_SUPERADMIN],
			selectedClient: [ClientContextGetters.SELECTED_CLIENT],
		}),
		routeLink() {
			return this.$route.name;
		},
		isAdminPage() {
			if (this.$route.name == 'AdminUserManagementEdit') return true;
			return false;
		},

		//FOR ADMIN-USER PERMISSIONS
		disableForm() {
			if (this.$route.name == 'AdminUserManagementEdit') {
				return !this.isAdmin;
			} else {
				if (this.isAdmin) return false;
				if (
					this.$route.name == 'ClientUserManagementEdit' &&
					this.hasPermissions([
						Permissions.Tools.UserManagement.View,
					]) &&
					this.hasPermissions([Permissions.Tools.UserManagement.Edit])
				)
					return false;
				if (
					this.$route.name == 'ClientUserManagementAdd' &&
					this.hasPermissions([Permissions.Tools.UserManagement.Add])
				)
					return false;
			}
			return true;
		},
	},
	mounted() {
		if (this.selectedUser) {
			(this.Id = this.selectedUser.Id),
				(this.FirstName = this.selectedUser.FirstName);
			this.LastName = this.selectedUser.LastName;
			this.Username = this.selectedUser.Username;
			this.Email = this.selectedUser.Email;
			this.Password = this.selectedUser.Password;
			this.PhoneNumber = this.selectedUser.PhoneNumber;
			this.Address = this.selectedUser.Address;
			this.City = this.selectedUser.City;
			this.State = this.selectedUser.State;
			this.ZipCode = this.selectedUser.ZipCode;
			this.Company = this.selectedUser.Company;
		}
	},
	methods: {
		togglePassVisibility() {
			this.showPassword = !this.showPassword;
		},
		toggleConfirmPassVisibility() {
			this.showConfirmPassword = !this.showConfirmPassword;
		},
		onCancel() {
			this.$emit('cancel');
		},
		onSubmit() {
			if (this.$refs.form.validate()) {
				let formUser = {
					FirstName: this.FirstName,
					LastName: this.LastName,
					Username: this.Username,
					Email: this.Email,
					Password: this.Password,
					PhoneNumber: this.PhoneNumber,
					Address: this.Address,
					City: this.City,
					State: this.State,
					ZipCode: this.ZipCode,
					Company: this.Company,
				};
				if (this.Id) {
					formUser.Id = this.Id;
				}
				this.$emit('submit', formUser);
			}
		},
	},
};
</script>
<style scoped>
.po-password-strength-bar.secure {
	background-color: #4caf50;
	width: 100%;
}
</style>
